import { format, isValid, parse } from "date-fns";

/** YYYY-MM → "Jan 2020"; bare YYYY → unchanged; bad month still yields leading year if YYYY-… */
function formatYearMonth(raw: string, monthPattern: "MMM yyyy" | "MMMM yyyy"): string {
  const trimmed = raw.trim();
  if (/^\d{4}$/.test(trimmed)) {
    return trimmed;
  }
  const d = parse(trimmed, "yyyy-MM", new Date());
  if (isValid(d)) {
    return format(d, monthPattern);
  }
  const [y] = trimmed.split("-");
  return y && /^\d{4}$/.test(y) ? y : trimmed;
}

/** "Aug 2026" — from a YYYY-MM string (with the fallback chain above) or a Date. */
export function formatYearMonthShort(raw: string | Date): string {
  if (raw instanceof Date) return format(raw, "MMM yyyy");
  return formatYearMonth(raw, "MMM yyyy");
}

/** "August 2026" — same contract as formatYearMonthShort. */
export function formatYearMonthLong(raw: string | Date): string {
  if (raw instanceof Date) return format(raw, "MMMM yyyy");
  return formatYearMonth(raw, "MMMM yyyy");
}

export function formatExperienceDateRange(
  start?: string,
  end?: string,
  isCurrent?: boolean,
): string {
  const parts: string[] = [];
  if (start) parts.push(formatYearMonthLong(start));
  if (isCurrent) parts.push("Present");
  else if (end) parts.push(formatYearMonthLong(end));
  return parts.join(" - ");
}
